import {
  DecoratorWrapper,
  type DecoratorWrapperVariant,
} from '@natu/ui/Decorators/DecoratorWrapper';

import { type SBProps, type BlokItem, DynamicRender, sbEditable } from '../../../../utils';

interface SBDecoratorWrapperProps {
  variant?: DecoratorWrapperVariant;
  body?: BlokItem[];
}
export const SBDecoratorWrapper = ({ blok }: SBProps<SBDecoratorWrapperProps>) => {
  const { variant, body } = blok;

  return (
    <DecoratorWrapper variant={variant} {...sbEditable(blok)}>
      <DynamicRender data={body} />
    </DecoratorWrapper>
  );
};
